module.exports = __webpack_public_path__ + "img/dynamic-17.9e7f6983.png";